'use client';

import React, { useEffect, useState } from 'react';
import './watermark-overlay.css';

interface DynamicWatermarkProps {
    text: string;
}

export const DynamicWatermark: React.FC<DynamicWatermarkProps> = ({ text }) => {
    const [position, setPosition] = useState({ x: 50, y: 50 });

    useEffect(() => {
        const moveWatermark = () => {
            const newX = Math.random() * 80 + 10;
            const newY = Math.random() * 80 + 10;
            setPosition({ x: newX, y: newY });
        };

        const interval = setInterval(moveWatermark, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div
                className='video-watermark-moving'
                style={{
                    position: 'absolute',
                    top: `${position.y}%`,
                    left: `${position.x}%`,
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    opacity: 0.5,
                    pointerEvents: 'none',
                    zIndex: 2147483647,
                    textShadow: '2px 2px 6px rgba(0,0,0,0.9)',
                    whiteSpace: 'nowrap',
                    transition: 'all 2s ease-in-out',
                    direction: 'rtl',
                    padding: '4px 8px',
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    borderRadius: '4px'
                }}
            >
                {text}
            </div>

            <div
                className='video-watermark-grid'
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    pointerEvents: 'none',
                    zIndex: 2147483646,
                    opacity: 0.2,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gridTemplateRows: 'repeat(4, 1fr)',
                    gap: '1rem',
                    padding: '2rem'
                }}
            >
                {[...Array(12)].map((_, i) => (
                    <div
                        key={i}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            transform: 'rotate(-25deg)',
                            textShadow: '0 0 8px rgba(0,0,0,0.6)',
                            whiteSpace: 'nowrap',
                            direction: 'rtl'
                        }}
                    >
                        {text}
                    </div>
                ))}
            </div>
        </>
    );
};

